import { LoadingButton } from "@mui/lab";
import { Button, Grid } from "@mui/material";

import { TextField } from "../../../components";

export default function CreateWorkflowForm({ formikProps }) {
  return (
    <Grid container spacing={4} style={{ marginTop: "8px" }}>
      <Grid item xs={12}>
        <TextField
          label="Workflow Name"
          name="workflowName"
          formikProps={formikProps}
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          label="Workflow Description"
          name="workflowDescription"
          formikProps={formikProps}
        />
      </Grid>

      <Grid item xs={12} style={{ padding: "0 24px 16px" }} />

      <Grid item xs />

      <Grid item>
        <Button variant="outlined" color="primary">
          Cancel
        </Button>
      </Grid>

      <Grid item>
        <LoadingButton
          onClick={formikProps.handleSubmit}
          disabled={!formikProps.dirty || !formikProps.isValid}
          loading={formikProps.isSubmitting}
          type="submit"
          variant="contained"
          color="primary"
        >
          Create Workflow
        </LoadingButton>
      </Grid>
    </Grid>
  );
}
